/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

//*************** Libreria para realizar pdfs **************************************/
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// ------------------- CONSULTAS A LA API---------------------------
import { obtenerProductosCodigo } from "../../../../../API/Global/Productos/ProductosRequests";

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import QRCode from 'qrcode';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const EtiquetaProductoQR = () => {
  const { CodigoP } = useParams();

  // OBTENER LA INFORMACION
  const obtenerInformacion = async (CodigoP) => {
    const codigos = CodigoP.split(',');
    const promesasProductos = codigos.map(codigo => obtenerProductosCodigo(codigo));
    const productosTempo = await Promise.all(promesasProductos);
    const productos1 = productosTempo.flat();
    generarPDF(productos1);
  };

  useEffect(() => {
    if (CodigoP) {
      obtenerInformacion(CodigoP);
    }
  }, [CodigoP]);

  const generarPDF = ( productosTempo ) => {

    const contenido = [];

    productosTempo.forEach((producto, index) => {
      let CodigoQR =
      console.log(QRCode);
      QRCode.toDataURL(`${producto?.CodigoProducto}`, { errorCorrectionLevel: 'Q' }, (err, url) => {
        console.log(url, err);
        CodigoQR = url;
      })

      contenido.push({
        columns: [
          {
            margin: [0, 0, 0, 0],
            table: {
              widths: ["*"],
              body: [
                [
                  {
                    image: CodigoQR,
                    width: 78,
                    height: 78,
                    margin: [-20, -5, 0, 0],
                  },
                ],
              ],
            },
            layout: {
              defaultBorder: false,
            }
          },

          // {
          //   text: [
          //     { text: `${producto?.CodigoProducto}\n`, style: "titulo1" },
          //     { text: "      "},
          //     { text: `${producto?.NombreProducto}\n`, style: "infoGeneral" },
          //     { text: "      "},
          //     { text: `${producto?.NombreCategoria}\n`, style: "infoGeneral2"},

          //   ],
          //   margin: [-38, 5, -7, 0],
          // },

          {
            margin: [-38, 5, -7, 0],  
            table: {
              widths: ["*"], 
              body: [
                [
                  {
                    text: `${producto?.CodigoProducto}`,
                    style: "titulo1",
                    alignment: "center", 
                  },
                ],
                [
                  {
                    text: `${producto?.NombreProducto?.substring(0, 60) || ''}`,
                    // text: `${producto?.NombreProducto || ''}`,
                    style: "infoGeneral",
                  },
                ],
                [
                  {
                    text: `- ${producto?.NombreCategoria} -`,
                    style: "infoGeneral2",
                    margin: [0, 2, 0, 0]
                  },
                ],
              ],
            },
            layout: 'noBorders', 
          },

        ],
      },
      index < productosTempo.length - 1 ? { text: '', pageBreak: 'after' } : null
    );
    })


    const docDefinition = {
      pageSize: {
        width: 210,
        height: 72,
      },

      pageMargins: [10, 0, 10, 0],
      content: contenido,
      styles: {
        titulo1: {
          fontSize: 10.5,
          bold: true,
          alignment: "center",
        },
        infoGeneral: {
          fontSize: 8,
          bold: true,
          alignment: "center",
        },
        infoGeneral2: {
          fontSize: 8,
          alignment: "center",
        },
      },
    };

    pdfMake.createPdf(docDefinition).open({}, window);
  };
};

export default EtiquetaProductoQR;
